var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.2222C22 11.4 21.932 10.8 21.7846 10.1778H12.2041V13.8889H17.8277C17.7143 14.8111 17.1021 16.2 15.7415 17.1333L15.7224 17.2575L18.7516 19.5573L18.9615 19.5778C20.8889 17.8333 22 15.2666 22 12.2222Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 22C14.9591 22 17.272 21.1111 18.9614 19.5778L15.7415 17.1333C14.8798 17.7222 13.7233 18.1333 12.2041 18.1333C9.50567 18.1333 7.21543 16.3889 6.39903 13.9778L6.27936 13.9877L3.12957 16.3766L3.08838 16.4889C4.76637 19.7555 8.2131 22 12.2041 22Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39906 13.9778C6.18364 13.3556 6.05897 12.6889 6.05897 12C6.05897 11.3111 6.18364 10.6445 6.38773 10.0222L6.38202 9.88973L3.19276 7.46246L3.08841 7.5111C2.39683 8.86668 2 10.3889 2 12C2 13.6111 2.39683 15.1333 3.08841 16.4889L6.39906 13.9778Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 5.86664C14.1201 5.86664 15.4126 6.67775 16.1496 7.35557L19.0294 4.6C17.2608 2.98889 14.9591 2 12.2041 2C8.2131 2 4.76637 4.24443 3.08838 7.51107L6.38769 10.0222C7.21543 7.61111 9.50567 5.86664 12.2041 5.86664Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMobile);
export default __webpack_public_path__ + "static/media/google-mobile.207992c2b1d0e2a1796184b3b2359d62.svg";
export { ForwardRef as ReactComponent };